import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { EyeOff } from 'lucide-react';
import { apiRequests } from '../../shared/api/apiRequests';
import { formatImageUrl } from '../../shared/utils/formatImageUrl';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const LanguagesPage = () => {
  const [languages, setLanguages] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const location = useLocation();

  const getData = (count = 10, offset = 0) => {
    apiRequests.languages.get(count, offset).then((res) => setLanguages(res));
  };

  useEffect(() => {
    // getData()
  }, []);

  const handleDelete = (id) => {
    apiRequests.languages.delete(id).then(() =>
      setLanguages((prev) => ({
        totalCount: prev.totalCount,
        items: prev.items.filter((i) => i.id !== id),
      })),
    );
  };

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.languages.getFiltered(searchValue).then((res) => setLanguages(res));
    }
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск языков..."
        createLink={`${location.pathname}/create`}
      />

      <div className="mb-3">
        {languages.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          languages.items?.map((item) => (
            <EntityCard
              key={item.id}
              image={formatImageUrl(item.iconPath)}
              title={
                <span className="d-flex align-items-center gap-2">
                  {item.title}
                  {item.isHidden && <EyeOff size={16} color="#8c8c8c" title="Язык скрыт" />}
                </span>
              }
              editLink={`${location.pathname}/${item.id}`}
              localizationLink={`${location.pathname}/${item.id}/localization`}
              onDelete={!item.isDefault ? () => handleDelete(item.id) : null}
            />
          ))
        )}
      </div>

      <Pagination
        count={languages.totalCount}
        itemsPerPage={10}
        onChange={(page) => getData(10, page * 10)}
      />
    </>
  );
};

export default LanguagesPage;
